module.exports = __webpack_public_path__ + "img/webmag_analytics.ed481c2f.jpg";